
import { getCmsEnhanceTrips } from "../../../app/api/getCmsEnhanceTrips";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IApiResponse } from "../../../Orchestrator/Types/Index";
import { ICmsEnhancedTripResponse, ICmsEnhancedTrips } from "../../../Orchestrator/Types/Interface/ICmsEnhancedTrip";


class GetCMSEnhancedTripsAction extends BaseAction<ICmsEnhancedTrips[], void> {
    override async run(): Promise<ICmsEnhancedTrips[] | null> {
        let listOfEnhancedTrips: ICmsEnhancedTrips[] = [];
        try {
            const response: IApiResponse<ICmsEnhancedTripResponse> = await getCmsEnhanceTrips();

            if (response.status === "ok" && response.answer) {
                const enhancedTrips = response.answer.data;
                if (enhancedTrips.length > 0) {
                    listOfEnhancedTrips = enhancedTrips
                    updateRecoilState("enhancedTripsResponseAtom", listOfEnhancedTrips);
                } else {
                    console.warn("No enhanced trips available.");
                }
            } else {
                console.warn("Failed to fetch enhanced trips.");
            }
        } catch (error: any) {
            console.error("Error fetching enhanced trips:", error);
        } finally {
            return listOfEnhancedTrips;
        }
    }
}

export const getCMSEnhancedTripsAction = new GetCMSEnhancedTripsAction()